module.exports = __webpack_public_path__ + "static/media/image_5.42e0d295.jpg";